import i18n from "i18next";
import {DropdownItemProps} from "semantic-ui-react";

import {IVirtualizedTableColumn} from "../VirtualizedTableInterfaces";
import {OptionTextDto} from "../../../services/Client";

export class Utils {
    // private keyRowMap: {[key: string]: IDynTableRow} = {};
    /**
     *  get a table row by his key
     */
    getTableRowByKey(key: string, rows: IVirtualizedTableColumn[]) {
        // if (this.keyRowMap[key])
        //     return this.keyRowMap[key];
        const element = rows.find((item: IVirtualizedTableColumn) => item.key === key) as IVirtualizedTableColumn;
        // this.keyRowMap[key] = element;
        return element;
    }
}

export function sortCaseInsensitive(a: string, b: string): number {
    return a.localeCompare(b, 'de', {sensitivity: 'base'});
}

export function sortOptionTypes(a: any, b: any): number {
    return (i18n.t("GLOBAL:" + a) + " (" + a + ')').localeCompare(
        (i18n.t("GLOBAL:" + b) + " (" + b + ')'), 'de', {sensitivity: 'base'});
}

export enum IdentifierInputType {
    MANUAL_INPUT = 1,
    ALL_PDIP_DS_INPUT = 2,
    UNUSED_PDIP_DS_INPUT = 3
}

export function getIdentifierInputTypes(): DropdownItemProps[] {
    return [
        {
            key: IdentifierInputType.MANUAL_INPUT,
            value:IdentifierInputType.MANUAL_INPUT,
            text: i18n.t("MANUAL_INPUT"),
            id: "Manual_Input"
        },
        {
            key: IdentifierInputType.ALL_PDIP_DS_INPUT,
            value: IdentifierInputType.ALL_PDIP_DS_INPUT,
            text: i18n.t("ALL_PDIP_DS_INPUT"),
            id: "All_PDIP_DS_Input"
        },
        {
            key: IdentifierInputType.UNUSED_PDIP_DS_INPUT,
            value: IdentifierInputType.UNUSED_PDIP_DS_INPUT,
            text: i18n.t("UNUSED_PDIP_DS_INPUT"),
            id: "Unused_PDIP_DS_Input"
        }
    ];
}

export function sortTexts(a: OptionTextDto, b: OptionTextDto): number {
    return (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1;
}

export const formatDate = (dateMilis: number) => {
    const date = new Date(dateMilis);
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    const seconds = `0${date.getSeconds()}`.slice(-2);

    return `${day}.${month}.${date.getFullYear()} ${hours}:${minutes}:${seconds}`;
};

export const SYSTEM_USER = "SYSTEM";



// WEBPACK FOOTER //
// ./src/components/Table/dataHandler/Utils.ts